module.exports = __webpack_public_path__ + "c483d8050ae3750b424642d56c34c70e.jpg";